import styles from './styles.module.scss';
import { DropZone, ComponentConfig } from '@measured/puck';
import getClassNameFactory from '../../commonFunction';
import { Section } from '../../Section';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../../puck/reusable-props/Border';
import {
  paddingFields,
  PaddingProps,
} from '../../../puck/reusable-props/padding';
import showComponent, {
  showComponentProps,
} from '../../../puck/reusable-props/showComponent';
import { marginFields, MarginProps } from '../../../puck/reusable-props/margin';
import { ReduxSelectorProps } from '../../../services/constants';
import {
  getBorderProps,
  getcurrentDeviceType,
  getMarginStyles,
  getPaddingStyles,
} from '../../../utils/helper';
import CustomTooltip from '../../../../components/common/tooltip';
import { backgroungFields } from '../../../puck/reusable-props/backgroungFields';

const getClassName = getClassNameFactory('Grid', styles);

export type GridProps = {
  numColumns: number;
  gap: number;
  background: {
    color: string;
    isInherit: boolean;
  };
  border: IBorderValueProps;
} & PaddingProps &
  showComponentProps &
  MarginProps;

export const GridInternal = ({
  useAppSelector,
}: ReduxSelectorProps): ComponentConfig<GridProps> => {
  return {
    label: (
      <CustomTooltip title="Grid">
        <span>Grid</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      ...paddingFields,
      ...marginFields,
      ...backgroungFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border
            value={value}
            onChange={onChange}
            title="Border"
            showWidthProps={true}
          />
        ),
      },
      numColumns: {
        type: 'number',
        label: 'Number of columns',
        min: 1,
        max: 12,
      },
      gap: {
        label: 'Gap',
        type: 'number',
        min: 0,
      },
    },
    defaultProps: {
      showComponent: ['desktop', 'tablet', 'mobile'],
      background: {
        color: '#ffffff',
        isInherit: false,
      },
      numColumns: 4,
      gap: 24,
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      margin: {
        desktop: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },
      ...borderProps,
    },
    render: ({
      gap,
      numColumns,
      margin,
      border,
      padding,
      showComponent,
      editMode,
      background,
    }) => {
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getMarginStyles(margin, currentDeviceType);
      return (
        <Section
          style={{
            ...marginStyles,
            backgroundColor: background?.isInherit
              ? 'inherit'
              : background?.color,
            ...getBorderProps(border, currentDeviceType, true),
            ...getPaddingStyles(padding, currentDeviceType),
          }}
          className={`${showComponent?.includes(currentDeviceType) ? '' : '!hidden'}  ${border?.borderStyle?.[currentDeviceType]}`}>
          <DropZone
            zone="grid"
            disallow={['Hero', 'Stats']}
            className={getClassName()}
            style={{
              gap,
              gridTemplateColumns: `repeat(${numColumns}, 1fr)`,
            }}></DropZone>
        </Section>
      );
    },
  };
};
